import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { HELVETICA, TEAL, BLUE } from 'components/styles'
import PopoverHeader from './PopoverHeader'
import { setCustomFieldArray } from 'controllers/logic'

const W = 12
const H = 18
const TOP_H = 4

const CUSTOM_GRAY = '#f4f4f4'

const Container = styled.div`
  height: 26em;
  width: 33em;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0 4px 10px 8px rgba(175,175,175,0.27);
`
const Content = styled.div`
  _padding: 2em;
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`
const ContentContainer = styled.div`
  padding: 1.3em 1.5em 1.3em 1.5em;
  display: flex;
  justify-content: space-around;
  _background-color: #c3c3c3;
`
const LayoutPreviewContainer = styled.div`
  width: ${W}em;
  height: 20em;
  display: flex;
  flex-direction: column;

  _background-color: #c3c3c3;
`
const PreviewHeader = styled.div`
  height: 2em;
  ${HELVETICA}
  font-size: 21px;
  font-weight: 100;
  letter-spacing: 0.6px;
  text-align: center;
`
const GridContainer = styled.div`
  height: ${H}em;
  border: ${props => props.selected ? `solid 3px ${BLUE}` : `solid 1px ${TEAL}`};
  cursor: pointer;
  display: flex;
  background-color: ${TEAL};
  position: relative;
`
const TopBlock = styled.div`
  height: ${TOP_H}em;
  width: 100%;
  background-color: ${CUSTOM_GRAY}
`
const LineHor = styled.div`
  width: 100%;
  border-bottom: solid 1px ${CUSTOM_GRAY};
  position: absolute;
  top: ${props => `${props.top}em`}
`
const LineVert = styled.div`
  height: 100%;
  border-left: solid 1px ${CUSTOM_GRAY};
  position: absolute;
  left: ${props => `${props.left}em`}
`

class InstaLayout extends Component {

  constructor (props) {
    super(props)
    this.state = {
      activeTab: 0
    }
  }

  componentWillMount () {
    this.props.updatePosition('30%', '63%')
  }

  onClick = (n) => {
    return (e) => {
      const { dispatch, value, appId, path } = this.props
      if (n !== value) {
        dispatch(setCustomFieldArray(appId, path, n))
      }
    }
  }

  renderLayoutPreview (n) {
    const { value } = this.props
    const cellSize = W / n
    const linesHor = []
    const linesHorAmount = (H - TOP_H) / cellSize
    for (let i = 0; i < linesHorAmount; i++) {
      linesHor.push(cellSize * i + TOP_H)
    }
    const linesVert = []
    const linesVertAmount = n - 1
    for (let i = 1; i <= linesVertAmount; i++) {
      linesVert.push(cellSize * i)
    }
    return (
      <LayoutPreviewContainer>
        <PreviewHeader>{n} per row</PreviewHeader>
        <GridContainer
          selected={n === value}
          onClick={this.onClick(n)}
        >
          <TopBlock />
          {linesHor.map((top, i) => <LineHor key={i} top={top} />)}
          {linesVert.map((left, i) => <LineVert key={i} left={left} />)}
        </GridContainer>
      </LayoutPreviewContainer>
    )
  }

  renderContent () {
    return (
      <ContentContainer>
        {this.renderLayoutPreview(3)}
        {this.renderLayoutPreview(4)}
      </ContentContainer>
    )
  }

  render () {
    const { title, closeMyself } = this.props
    return (
      <Container>
        <PopoverHeader
          title={title}
          onClose={closeMyself}
          helpTooltip={'Configure number of columns'}
        />
        <Content>
          {this.renderContent()}
        </Content>
      </Container>
    )
  }
}

InstaLayout.propTypes = {
  closeMyself: PropTypes.func,
  value: PropTypes.number,
  path: PropTypes.array,
  appId: PropTypes.string,
  title: PropTypes.string,
  updatePosition: PropTypes.func,
}

export default connect()(InstaLayout)



// WEBPACK FOOTER //
// ./src/components/editor/popovers/InstaLayout.js